import type { ReactNode } from 'react'
import React from 'react'
import { Nav, Tab, Row, Col } from 'react-bootstrap'
import map from 'lodash/map'

export type SideNavigationProps = { navigationLinks: string[]; children: ReactNode }
export const SideNavigation = ({ navigationLinks, children }: SideNavigationProps) => {
  return (
    <Row>
      <Col md={2} className="shadow-sm border-end" style={{ minHeight: '80vh' }}>
        <Nav variant="pills" className="flex-column">
          {map(navigationLinks, (link) => (
            <Nav.Link key={link} eventKey={link}>
              {link}
            </Nav.Link>
          ))}
        </Nav>
      </Col>
      <Col md={10}>
        <Tab.Content>{children}</Tab.Content>
      </Col>
    </Row>
  )
}
